export enum MenuItemType {
  CategoryLinkMultiple = 'category_link_multiple',
  CategoryLink = 'category_link',
  PageLink = 'page_link',
  PostLink = 'post_link',
  ExternalLink = 'external_link',
  SocialLinks = 'social_links',
  Newsletter = 'newsletter'
}



// WEBPACK FOOTER //
// ./src/module/Model/Menu/item/MenuItemType.ts